export interface BrandConfig {
    company: { slug: string; name: string };
    logo_url: string;
    loginpage_logo_url: string;
    palette: { primary: string; secondary?: string; accent?: string };
    contacts?: {
      renewal?: { name?: string; phone?: string; email?: string };
      success?: { name?: string; phone?: string; email?: string };
    };
    social_links?: { facebook?: string; linkedin?: string, instagram?: string };
    legal?: { copyright?: string; privacy_url?: string; terms_url?: string, ca_privacy_url?: string };
    badges?: { [k: string]: { visible?: boolean; img?: string; url?: string } };
    icons?: Record<string, string>;
  }
  
  function timeout<T>(p: Promise<T>, ms = 800): Promise<T> {
    return new Promise((resolve, reject) => {
      const t = setTimeout(() => reject(new Error('timeout')), ms);
      p.then(v => { clearTimeout(t); resolve(v); }, e => { clearTimeout(t); reject(e); });
    });
  }
  
  export async function loadBrandConfig(): Promise<BrandConfig> {
    const params = new URLSearchParams(window.location.search);
    const qsBrand = params.get('brand');
    const slug = (await (async () => {
      const { detectBrandSlug } = await import('./hostMap');
      return detectBrandSlug(window.location.hostname, qsBrand);
    })());
  
    // try {
    //   const resp = await timeout(fetch('/api/v1/brand', {
    //     headers: { 'Accept': 'application/json', 'X-Brand-Host': window.location.host }
    //   }), 800);
    //   if (resp.ok) {
    //     const data = await resp.json();
    //     // normalize to BrandConfig-ish
    //     return {
    //       company: data.company ?? { slug, name: slug },
    //       logo_url: data.logo_url,
    //       palette: data.palette ?? data.colors ?? {},
    //       contacts: data.contacts,
    //       social_links: data.social_links ?? data.social,
    //       legal: data.legal,
    //       badges: data.badges,
    //       icons: data.icons
    //     } as BrandConfig;
    //   }
    // } catch (_) { /* swallow & fall back */ }
  
    const fallback = await fetch(`/brands/${slug}.json`, { cache: 'no-cache' });
    if (!fallback.ok) throw new Error(`Missing brand file: ${slug}.json`);
    return await fallback.json();
  }
  